import { d as BarGaugeSizing } from '../../../../../index-DuYVZf5J.js';

"use strict";
const pluginVersion = "13.0.0-pre";
const defaultGaugePanelEffects = {
  barGlow: false,
  centerGlow: false,
  gradient: true
};
const defaultOptions = {
  barShape: "flat",
  barWidthFactor: 0.5,
  effects: {},
  endpointMarker: "point",
  minVizHeight: 75,
  minVizWidth: 75,
  segmentCount: 1,
  segmentSpacing: 0.3,
  shape: "gauge",
  showThresholdLabels: false,
  showThresholdMarkers: true,
  sizing: BarGaugeSizing.Auto,
  sparkline: true,
  textMode: "auto"
};

export { defaultGaugePanelEffects, defaultOptions, pluginVersion };
